export default class Step1{
	constructor(view){
		console.log('Step1 :: init',view);

		this.view 		= view;
		this.inputs 	= this.view.querySelectorAll('input');

	}

}